import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const SESSION_KEY = 'delos_session_id';

export const getSessionId = () => {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `sess-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

export const matchWorkers = async (prompt) => {
  const { data } = await axios.post(`${API}/match`, {
    prompt,
    session_id: getSessionId(),
  });
  return data;
};

export const hireWorker = async ({ workerId, workerName, role, isCustom = false }) => {
  const { data } = await axios.post(`${API}/hire`, {
    worker_id: workerId,
    worker_name: workerName,
    role,
    session_id: getSessionId(),
    is_custom: isCustom,
  });
  return data;
};
